import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=a73b7c1c&scoped=true&"
import script from "./PostList.vue?vue&type=script&lang=js&"
export * from "./PostList.vue?vue&type=script&lang=js&"
import style0 from "./PostList.vue?vue&type=style&index=0&id=a73b7c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73b7c1c",
  null
  
)

export default component.exports